/// <reference types="vite/client" />

declare const __APP_VERSION__: string;
declare const __APP_BUILT_AT__: number;

/**
 * Build flavour switches:
 *  - development / preview: pending_review art and dev test art are allowed
 *  - production: only approved art (the release check enforces it)
 */
export const BUILD = {
  mode: import.meta.env.MODE,
  isProduction: import.meta.env.MODE === "production",
  allowPendingArt: import.meta.env.MODE !== "production",
  allowTestArt: import.meta.env.MODE !== "production",
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined) ?? "",
  /** https origin of the deployed game; the APK uses it for the API and updates. */
  publicOrigin: ((import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined) ?? "").replace(/\/$/, ""),
  /**
   * Where this build ships. "play" is the Google Play app: AdMob ads, updates
   * only through Play, no APK downloads or update panel. "web" is the site and
   * the sideloaded APK with live updates.
   */
  store: (import.meta.env.VITE_STORE as string | undefined) === "play" ? ("play" as const) : ("web" as const),
  /** Real AdMob units (Play release builds); anything else uses Google's test units. */
  liveAds: (import.meta.env.VITE_ADS as string | undefined) === "live",
  /** Unique per build (commit and build time), so every deploy reaches installed APKs. */
  version: __APP_VERSION__,
  builtAt: __APP_BUILT_AT__,
} as const;
